import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import ToastHelper from "@/utils/toastHelper";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const submit = (e) => { e.preventDefault(); ToastHelper.success(`Reset link sent to ${email}`); };
  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="wc-card p-8">
        <Link to="/login" className="text-sm text-slate-500 hover:text-[#0A2540] inline-flex items-center gap-1 mb-4"><ArrowLeft className="w-3.5 h-3.5" /> Back to login</Link>
        <h1 className="text-2xl font-display font-extrabold text-[#0A2540]">Reset your password</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">Enter your email and we'll send you a secure reset link.</p>
        <form onSubmit={submit} data-testid="forgot-form">
          <label className="wc-label">Email</label>
          <div className="relative"><Mail className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
            <input required type="email" className="wc-input pl-9" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" /></div>
          <button type="submit" className="wc-btn-primary w-full justify-center mt-5" data-testid="forgot-submit">Send reset link</button>
        </form>
      </div>
    </div>
  );
}
